import { EqlAttributeConfigurationDc } from "@evergis/api";

export enum LayerResourceMode {
  Info,
  Attributes,
  RelatedData,
}

export type EqlAttribute = EqlAttributeConfigurationDc & {
  isNew?: boolean;
  sysAttribute?: boolean;
  id?: string;
};
